window.addEventListener('load',function(){
    if(location.href.indexOf('#')>-1){
        const target = $(location.hash);
        if(!target.length) return;
        const parent = target.parents('.element-type-gridelements-container:first');
        if(!parent.length) return;
        const parentId = parent.attr('id');
        
        [].forEach.call(parent[0].classList,function(className){
            if(className.indexOf('bg-skewed')>-1){
                $('<style>#'+parentId+'.'+className+'::after{display:none;}</style>').appendTo('body');
                setTimeout(function(){$('<style>#'+parentId+'.'+className+'::after{display:block;}</style>').appendTo('body')},100);
            }
        });
    }
});